import { Stack } from "@mui/material"
import React, { useState } from "react"
import UseGetStepHookDucPage from "../UseGetStepHookDucPage"
import PiModal from "./PiModal"
import DUCDeleteModal from './DUCDeleteModal';
import GeneralBlockStepper from "./GeneralBlockStepper";
import GeneralBlockButtons from "./GeneralBlockButtons";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";

const GeneralBlockComponent = () => {
    const [activeStep, setActiveStep] = useState(1);
    //We need expiry and expired because we need a different 
    //status chip for each one
    const [expiring, setExpiring] = useState(false);
    const [expired, setExpired] = useState(false);
    const [declined, setDeclined] = useState(false);
    const [checkedCurrentStatus, setCheckedCurrentStatus] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    // const [secondDucExists, setSecondDucExists] = useState(false)
    const [cancelRefresh, setCancelRefresh] = useState(false)
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });
    const ducData = ducDataObject?.GENERAL?.[ducDataObject?.GENERAL.length - 1]

    UseGetStepHookDucPage(ducData, setActiveStep, setExpired, setExpiring, setDeclined, setCheckedCurrentStatus)

    return (
        <Stack
            component="section"
            aria-labelledby="general-use-header"
            flexDirection="column"
            justifyContent="space-between"
            gap={3}
            padding="20px"
            sx={{
                backgroundColor: "white"
            }}>
            <PiModal open={open} setOpen={setOpen} type="GENERAL"/>
            <DUCDeleteModal
                open={openDeleteModal}
                setOpen={setOpenDeleteModal}
                type="GENERAL"
                cancelRefresh={cancelRefresh}
                setCancelRefresh={setCancelRefresh}/>

            <GeneralBlockButtons
                expired={expired}
                expiring={expiring}
                setOpen={setOpen}
                setCancelRefresh={setCancelRefresh}
                cancelRefresh={cancelRefresh}
                setOpenDeleteModal={setOpenDeleteModal}
                checkedCurrentStatus={checkedCurrentStatus}/>

            <Stack>
                {ducDataObject?.GENERAL.map((ducData: any, index: number) => {
                    return (
                        <GeneralBlockStepper
                            ducData={ducData}
                            declined={declined}
                            expired={expired}
                            key={index}
                            index={index}
                            activeStep={activeStep}
                        />
                    )
                })}
            </Stack>


        </Stack>
    )


}


export default GeneralBlockComponent